<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <loading-overlay :loading="loading" />
        <div class="d-flex w-100 justify-content-between">
          <div>
            <b-tabs>
              <b-tab @click="setFilter('both')" active title="مشتركة" />
              <b-tab @click="setFilter('ngo')" title="للمنظمة" />
              <b-tab @click="setFilter('guest')" title="للجمهور" />
            </b-tabs>
          </div>
          <div>
            <b-button
              v-can="{ slug: $route.meta.slug, action: 'C' }"
              @click="
                $refs.faqModal.init({ type: 'both' });
                categoryModal = true;
              "
              class="d-flex align-items-center"
              variant="success"
            >
              <feather-icon icon="PlusIcon" class="mr-25" />
              إضافة
            </b-button>
          </div>
        </div>
        <b-list-group
          class="w-50"
          v-if="categories.length > 0"
          type="margin"
          accordion
        >
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            v-for="item in categories"
            :key="item.id"
          >
            <div>
              {{ item.name_ar }}
            </div>

            <div>
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                @click="onDeleteClicked(item.id)"
                variant="flat-danger"
                class="btn-icon rounded-circle"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'U' }"
                @click="onEditClicked(item)"
                variant="flat-info"
                class="btn-icon rounded-circle"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </div>
          </b-list-group-item>
        </b-list-group>
        <div class="text-center p-1" style="opacity: 0.8" v-else>
          <h5>
            <feather-icon class="mx-25" icon="AlertTriangleIcon" />

            لا يوجد سجلات حتى الآن
          </h5>
        </div>
      </div>
    </b-card>
    <form-modal
      ref="faqModal"
      title="إضافة تصنيف"
      :loading="loading || working"
      :formSchema="faqFormSchema"
      v-model="categoryModal"
      @confirm="onConfirm"
    >
      <template #type="{ form }">
        <b-form-radio-group
          :options="typeOptions"
          class="my-1"
          v-model="form.type"
        >
        </b-form-radio-group>
      </template>
    </form-modal>
  </div>
</template>

<script>
import {
  BRow,
  BDropdown,
  BDropdownItem,
  BCol,
  BCard,
  BButton,
  BFormRadioGroup,
  BTab,
  BTabs,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapActions, mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";

export default {
  components: {
    BRow,
    BDropdown,
    BDropdownItem,
    BCol,
    BCard,
    BButton,
    BFormRadioGroup,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    MinistryBreadcrumbs,
    FormModal,
    LoadingOverlay,
  },

  data() {
    return {
      categoryModal: false,
      mainTitle: "تصنيفات الأسئلة",
      filter: "both",
      typeOptions: [
        {
          text: "للمنظمة",
          value: "interior",
        },
        {
          text: "للجمهور",
          value: "exterior",
        },
        {
          text: "مشتركة",
          value: "both",
        },
      ],
      faqFormSchema: {
        type: {
          key: "type",
        },

        name_ar: {
          component: "FormInput",
          key: "name_ar",
          attrs: {
            label: "اسم التصنيف",
            rules: "required",
          },
        },
      },
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "تصنيفات الأسئلة",
          active: true,
        },
      ],
    };
  },
  created() {
    this.fetchCategories();
  },
  computed: {
    ...mapGetters("Ministry/Settings/FAQCategories", [
      "loading",
      "working",
      "ngoCategories",
      "guestCategories",
      "allCategories",
    ]),
    categories() {
      return this.filter === "both"
        ? this.allCategories
        : this.filter === "ngo"
        ? this.ngoCategories
        : this.guestCategories;
    },
  },
  methods: {
    ...mapActions("Ministry/Settings/FAQCategories", [
      "fetchCategories",
      "editCategory",
      "addCategory",
      "deleteCategory",
    ]),
    setFilter(filter) {
      this.filter = filter;
    },
    async onConfirm(form) {
      if (form.id) {
        await this.editCategory(form);
      } else {
        await this.addCategory(form);
      }
      this.categoryModal = false;
    },

    onEditClicked(question) {
      this.$refs.faqModal.init(question);
      this.categoryModal = true;
    },
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف التصنيف ؟", {
          title: "تأكيد حذف التصنيف",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.deleteCategory(id);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
